// Share ONE in-flight async operation between concurrent callers. While a run is
// pending every caller gets the same promise; once it settles (either way) the next
// call starts a fresh run. Used to make conversation creation single-flight: each
// POST /api/conversations mints a NEW conversation server-side, so two racing sends
// must never fire two of them.
export function createSingleFlight<T>(): (fn: () => Promise<T>) => Promise<T> {
  let inFlight: Promise<T> | null = null;
  return (fn) => {
    if (!inFlight) {
      inFlight = fn().finally(() => {
        inFlight = null;
      });
    }
    return inFlight;
  };
}
